import { render, staticRenderFns } from "./AnswerContent.vue?vue&type=template&id=41d826b4&scoped=true&"
import script from "./AnswerContent.vue?vue&type=script&lang=js&"
export * from "./AnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./AnswerContent.vue?vue&type=style&index=0&id=41d826b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d826b4",
  null
  
)

export default component.exports